import { ButtonSecondary } from "@src/Components/Button"
import {
  Content,
  Heading,
  Panel,
  PanelContainer,
  SubHeading,
} from "@src/Components/Common"
import { Link } from "@src/Components/Link"
import Tooltip from "@src/Components/Tooltip"
import * as React from "react"

import MessageContainer from "../../../MessageContainer"
import {
  ButtonContainer,
  FooterText,
  HeadingGray,
  Icon,
  ResponsiveHeading,
  Row,
} from "./styles"

export type tOnSubmit = (data: any) => void

interface IVerifyEmail {
  height: number
  emailToVerify: string
  isResendDisabled: boolean
  resendTooltip: string
  onVerifyEmail: (username: string) => void
  showSupportModal: () => void
  redirectToSignup: () => void
}

const VerifyEmail = ({
  height,
  emailToVerify,
  isResendDisabled,
  resendTooltip,
  onVerifyEmail,
  showSupportModal,
  redirectToSignup,
}: IVerifyEmail) => {
  const goToSignupScreen = () => {
    redirectToSignup()
  }

  const resendVerificationCode = () => {
    onVerifyEmail(emailToVerify)
  }

  return (
    <Content height={height}>
      <MessageContainer />
      <PanelContainer height={height}>
        <Panel>
          <Row>
            <ResponsiveHeading>
              <Heading align="center" margin="20px 0px">
                Verify your email.
              </Heading>
            </ResponsiveHeading>
          </Row>
          <Row>
            <SubHeading>
              Check your email
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    emailToVerify && emailToVerify !== ""
                      ? ` at <b>${emailToVerify}</b>`
                      : "",
                }}
              />
              &nbsp;and click the link to activate your account.
            </SubHeading>
          </Row>
          <Row>
            <Icon src="images/icon_email_verified.svg" />
          </Row>
          <br />
          <Row>
            <HeadingGray>Didn&apos;t receive an email?</HeadingGray>
          </Row>
          <Row>
            <SubHeading>
              It may take a couple of minutes to arrive in your inbox. Please
              check your spam or junk folder if you don&apos;t see it.
            </SubHeading>
          </Row>
          <Row>
            <ButtonContainer>
              <ButtonSecondary
                onClick={resendVerificationCode}
                id="resend-email-button"
                width={170}
                margin={10}
                disabled={isResendDisabled}
                data-tooltip-id={
                  isResendDisabled ? "resend-email-tooltip" : undefined
                }
                style={{
                  opacity: isResendDisabled ? 0.6 : 1,
                  cursor: isResendDisabled ? "not-allowed" : "pointer",
                }}
              >
                Resend Email
              </ButtonSecondary>
              {isResendDisabled && (
                <Tooltip
                  id="resend-email-tooltip"
                  content={<p>{resendTooltip}</p>}
                  width="300px"
                  place="top"
                />
              )}
              <ButtonSecondary
                onClick={showSupportModal}
                id="contact-support-button"
                width={170}
                margin={10}
              >
                Contact Support
              </ButtonSecondary>
            </ButtonContainer>
          </Row>
          <Row>
            <FooterText>
              Or&nbsp;
              <Link onClick={goToSignupScreen}>
                use another email address instead.
              </Link>
            </FooterText>
          </Row>
        </Panel>
      </PanelContainer>
    </Content>
  )
}

export default VerifyEmail
